/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/project.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { ProjectServiceApplyBoardPresetBody } from '../models'
// @ts-ignore
import type { ProjectServiceCreateBoardColumnBody } from '../models'
// @ts-ignore
import type { ProjectServiceCreateLabelBody } from '../models'
// @ts-ignore
import type { ProjectServiceReorderBoardColumnsBody } from '../models'
// @ts-ignore
import type { ProjectServiceSetProjectMemberBody } from '../models'
// @ts-ignore
import type { ProjectServiceUpdateBoardColumnBody } from '../models'
// @ts-ignore
import type { ProjectServiceUpdateLabelBody } from '../models'
// @ts-ignore
import type { ProjectServiceUpdateProjectBody } from '../models'
// @ts-ignore
import type { RpcStatus } from '../models'
// @ts-ignore
import type { TrackerBoardColumnResponse } from '../models'
// @ts-ignore
import type { TrackerCreateProjectRequest } from '../models'
// @ts-ignore
import type { TrackerLabelResponse } from '../models'
// @ts-ignore
import type { TrackerListActivityResponse } from '../models'
// @ts-ignore
import type { TrackerListBoardColumnsResponse } from '../models'
// @ts-ignore
import type { TrackerListLabelsResponse } from '../models'
// @ts-ignore
import type { TrackerListProjectMembersResponse } from '../models'
// @ts-ignore
import type { TrackerListProjectsResponse } from '../models'
// @ts-ignore
import type { TrackerProjectMemberResponse } from '../models'
// @ts-ignore
import type { TrackerProjectResponse } from '../models'
/**
 * ProjectServiceApi - axios parameter creator
 */
export const ProjectServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Replaces the board with one of the presets. Refused while the board still holds tasks: the preset would have nowhere to put them.
     * @param {string} projectId
     * @param {ProjectServiceApplyBoardPresetBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceApplyBoardPreset: async (
      projectId: string,
      body: ProjectServiceApplyBoardPresetBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceApplyBoardPreset', 'projectId', projectId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceApplyBoardPreset', 'body', body)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/columns/preset`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a column to the board.
     * @param {string} projectId
     * @param {ProjectServiceCreateBoardColumnBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceCreateBoardColumn: async (
      projectId: string,
      body: ProjectServiceCreateBoardColumnBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceCreateBoardColumn', 'projectId', projectId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceCreateBoardColumn', 'body', body)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/columns`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a label.
     * @param {string} projectId
     * @param {ProjectServiceCreateLabelBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceCreateLabel: async (
      projectId: string,
      body: ProjectServiceCreateLabelBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceCreateLabel', 'projectId', projectId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceCreateLabel', 'body', body)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/labels`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a project. The caller becomes its first administrator, and the board is filled with one of the two column presets.
     * @param {TrackerCreateProjectRequest} body A new project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceCreateProject: async (
      body: TrackerCreateProjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceCreateProject', 'body', body)
      const localVarPath = `/api/v1/tracker/projects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a column. Tasks standing in it move to the column given in the request, so that nothing is left without a place on the board.
     * @param {string} id
     * @param {string} [moveIssuesToColumnId] Where the tasks standing in it go. Required whenever the column holds any.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceDeleteBoardColumn: async (
      id: string,
      moveIssuesToColumnId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectServiceDeleteBoardColumn', 'id', id)
      const localVarPath = `/api/v1/tracker/columns/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (moveIssuesToColumnId !== undefined) {
        localVarQueryParameter['moveIssuesToColumnId'] = moveIssuesToColumnId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a label and takes it off the tasks that carry it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceDeleteLabel: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectServiceDeleteLabel', 'id', id)
      const localVarPath = `/api/v1/tracker/labels/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceDeleteProject: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectServiceDeleteProject', 'id', id)
      const localVarPath = `/api/v1/tracker/projects/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one project.
     * @param {string} id Either the identifier or the key: both are unique, and the interface has the key more often than the identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceGetProject: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectServiceGetProject', 'id', id)
      const localVarPath = `/api/v1/tracker/projects/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a project. Its tasks go with it, and the key becomes free again. Recent events across the projects the caller can see — the hub\'s feed.
     * @param {Array<string>} [projectIds] Narrow the feed to these projects. Empty — every project the caller sees.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListActivity: async (
      projectIds?: Array<string>,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/activity`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (projectIds) {
        localVarQueryParameter['projectIds'] = projectIds
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the columns of a board, left to right.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListBoardColumns: async (
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceListBoardColumns', 'projectId', projectId)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/columns`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the labels of a project.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListLabels: async (
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceListLabels', 'projectId', projectId)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/labels`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the people on a project.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListProjectMembers: async (
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceListProjectMembers', 'projectId', projectId)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/members`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the projects the caller may see: public ones, plus private ones they belong to. System projects are left out unless asked for.
     * @param {boolean} [onlyMine] Only projects the caller belongs to.
     * @param {boolean} [includeSystem] Include projects owned by services rather than by people.
     * @param {string} [search]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {boolean} [archived] Archived projects instead of live ones. They are a separate tab in the hub, never a part of the usual list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListProjects: async (
      onlyMine?: boolean,
      includeSystem?: boolean,
      search?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      archived?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/projects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (onlyMine !== undefined) {
        localVarQueryParameter['onlyMine'] = onlyMine
      }

      if (includeSystem !== undefined) {
        localVarQueryParameter['includeSystem'] = includeSystem
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (archived !== undefined) {
        localVarQueryParameter['archived'] = archived
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes someone from a project.
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceRemoveProjectMember: async (
      projectId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceRemoveProjectMember', 'projectId', projectId)
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('projectServiceRemoveProjectMember', 'userId', userId)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/members/{userId}`
        .replace('{projectId}', encodeURIComponent(String(projectId)))
        .replace('{userId}', encodeURIComponent(String(userId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Sets the left-to-right order of the whole board in one call.
     * @param {string} projectId
     * @param {ProjectServiceReorderBoardColumnsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceReorderBoardColumns: async (
      projectId: string,
      body: ProjectServiceReorderBoardColumnsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceReorderBoardColumns', 'projectId', projectId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceReorderBoardColumns', 'body', body)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/columns/reorder`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds someone to a project, or changes the role of someone already on it.
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectServiceSetProjectMemberBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceSetProjectMember: async (
      projectId: string,
      userId: string,
      body: ProjectServiceSetProjectMemberBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('projectServiceSetProjectMember', 'projectId', projectId)
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('projectServiceSetProjectMember', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceSetProjectMember', 'body', body)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/members/{userId}`
        .replace('{projectId}', encodeURIComponent(String(projectId)))
        .replace('{userId}', encodeURIComponent(String(userId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a column. Fields left out keep their current values.
     * @param {string} id
     * @param {ProjectServiceUpdateBoardColumnBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceUpdateBoardColumn: async (
      id: string,
      body: ProjectServiceUpdateBoardColumnBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectServiceUpdateBoardColumn', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceUpdateBoardColumn', 'body', body)
      const localVarPath = `/api/v1/tracker/columns/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a label.
     * @param {string} id
     * @param {ProjectServiceUpdateLabelBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceUpdateLabel: async (
      id: string,
      body: ProjectServiceUpdateLabelBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectServiceUpdateLabel', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceUpdateLabel', 'body', body)
      const localVarPath = `/api/v1/tracker/labels/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a project. Fields left out keep their current values.
     * @param {string} id
     * @param {ProjectServiceUpdateProjectBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceUpdateProject: async (
      id: string,
      body: ProjectServiceUpdateProjectBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectServiceUpdateProject', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('projectServiceUpdateProject', 'body', body)
      const localVarPath = `/api/v1/tracker/projects/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProjectServiceApi - functional programming interface
 */
export const ProjectServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Replaces the board with one of the presets. Refused while the board still holds tasks: the preset would have nowhere to put them.
     * @param {string} projectId
     * @param {ProjectServiceApplyBoardPresetBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceApplyBoardPreset(
      projectId: string,
      body: ProjectServiceApplyBoardPresetBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListBoardColumnsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceApplyBoardPreset(
        projectId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceApplyBoardPreset']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a column to the board.
     * @param {string} projectId
     * @param {ProjectServiceCreateBoardColumnBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceCreateBoardColumn(
      projectId: string,
      body: ProjectServiceCreateBoardColumnBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerBoardColumnResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceCreateBoardColumn(
        projectId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceCreateBoardColumn']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a label.
     * @param {string} projectId
     * @param {ProjectServiceCreateLabelBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceCreateLabel(
      projectId: string,
      body: ProjectServiceCreateLabelBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerLabelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceCreateLabel(
        projectId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceCreateLabel']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a project. The caller becomes its first administrator, and the board is filled with one of the two column presets.
     * @param {TrackerCreateProjectRequest} body A new project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceCreateProject(
      body: TrackerCreateProjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerProjectResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceCreateProject(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceCreateProject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a column. Tasks standing in it move to the column given in the request, so that nothing is left without a place on the board.
     * @param {string} id
     * @param {string} [moveIssuesToColumnId] Where the tasks standing in it go. Required whenever the column holds any.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceDeleteBoardColumn(
      id: string,
      moveIssuesToColumnId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceDeleteBoardColumn(
        id,
        moveIssuesToColumnId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceDeleteBoardColumn']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a label and takes it off the tasks that carry it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceDeleteLabel(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceDeleteLabel(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceDeleteLabel']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceDeleteProject(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceDeleteProject(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceDeleteProject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one project.
     * @param {string} id Either the identifier or the key: both are unique, and the interface has the key more often than the identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceGetProject(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerProjectResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceGetProject(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceGetProject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a project. Its tasks go with it, and the key becomes free again. Recent events across the projects the caller can see — the hub\'s feed.
     * @param {Array<string>} [projectIds] Narrow the feed to these projects. Empty — every project the caller sees.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceListActivity(
      projectIds?: Array<string>,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListActivityResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceListActivity(
        projectIds,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceListActivity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the columns of a board, left to right.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceListBoardColumns(
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListBoardColumnsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceListBoardColumns(
        projectId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceListBoardColumns']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the labels of a project.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceListLabels(
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListLabelsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceListLabels(
        projectId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceListLabels']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the people on a project.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceListProjectMembers(
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListProjectMembersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceListProjectMembers(
        projectId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceListProjectMembers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the projects the caller may see: public ones, plus private ones they belong to. System projects are left out unless asked for.
     * @param {boolean} [onlyMine] Only projects the caller belongs to.
     * @param {boolean} [includeSystem] Include projects owned by services rather than by people.
     * @param {string} [search]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {boolean} [archived] Archived projects instead of live ones. They are a separate tab in the hub, never a part of the usual list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceListProjects(
      onlyMine?: boolean,
      includeSystem?: boolean,
      search?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      archived?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListProjectsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceListProjects(
        onlyMine,
        includeSystem,
        search,
        paginationPage,
        paginationPerPage,
        archived,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceListProjects']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes someone from a project.
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceRemoveProjectMember(
      projectId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceRemoveProjectMember(
        projectId,
        userId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceRemoveProjectMember']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Sets the left-to-right order of the whole board in one call.
     * @param {string} projectId
     * @param {ProjectServiceReorderBoardColumnsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceReorderBoardColumns(
      projectId: string,
      body: ProjectServiceReorderBoardColumnsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListBoardColumnsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceReorderBoardColumns(
        projectId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceReorderBoardColumns']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds someone to a project, or changes the role of someone already on it.
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectServiceSetProjectMemberBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceSetProjectMember(
      projectId: string,
      userId: string,
      body: ProjectServiceSetProjectMemberBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerProjectMemberResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceSetProjectMember(
        projectId,
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceSetProjectMember']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a column. Fields left out keep their current values.
     * @param {string} id
     * @param {ProjectServiceUpdateBoardColumnBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceUpdateBoardColumn(
      id: string,
      body: ProjectServiceUpdateBoardColumnBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerBoardColumnResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceUpdateBoardColumn(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceUpdateBoardColumn']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a label.
     * @param {string} id
     * @param {ProjectServiceUpdateLabelBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceUpdateLabel(
      id: string,
      body: ProjectServiceUpdateLabelBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerLabelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceUpdateLabel(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceUpdateLabel']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a project. Fields left out keep their current values.
     * @param {string} id
     * @param {ProjectServiceUpdateProjectBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectServiceUpdateProject(
      id: string,
      body: ProjectServiceUpdateProjectBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerProjectResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectServiceUpdateProject(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ProjectServiceApi.projectServiceUpdateProject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ProjectServiceApi - factory interface
 */
export const ProjectServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ProjectServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Replaces the board with one of the presets. Refused while the board still holds tasks: the preset would have nowhere to put them.
     * @param {string} projectId
     * @param {ProjectServiceApplyBoardPresetBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceApplyBoardPreset(
      projectId: string,
      body: ProjectServiceApplyBoardPresetBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListBoardColumnsResponse> {
      return localVarFp
        .projectServiceApplyBoardPreset(projectId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a column to the board.
     * @param {string} projectId
     * @param {ProjectServiceCreateBoardColumnBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceCreateBoardColumn(
      projectId: string,
      body: ProjectServiceCreateBoardColumnBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerBoardColumnResponse> {
      return localVarFp
        .projectServiceCreateBoardColumn(projectId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a label.
     * @param {string} projectId
     * @param {ProjectServiceCreateLabelBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceCreateLabel(
      projectId: string,
      body: ProjectServiceCreateLabelBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerLabelResponse> {
      return localVarFp
        .projectServiceCreateLabel(projectId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a project. The caller becomes its first administrator, and the board is filled with one of the two column presets.
     * @param {TrackerCreateProjectRequest} body A new project.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceCreateProject(
      body: TrackerCreateProjectRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerProjectResponse> {
      return localVarFp
        .projectServiceCreateProject(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a column. Tasks standing in it move to the column given in the request, so that nothing is left without a place on the board.
     * @param {string} id
     * @param {string} [moveIssuesToColumnId] Where the tasks standing in it go. Required whenever the column holds any.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceDeleteBoardColumn(
      id: string,
      moveIssuesToColumnId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .projectServiceDeleteBoardColumn(id, moveIssuesToColumnId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a label and takes it off the tasks that carry it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceDeleteLabel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .projectServiceDeleteLabel(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceDeleteProject(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .projectServiceDeleteProject(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one project.
     * @param {string} id Either the identifier or the key: both are unique, and the interface has the key more often than the identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceGetProject(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerProjectResponse> {
      return localVarFp
        .projectServiceGetProject(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a project. Its tasks go with it, and the key becomes free again. Recent events across the projects the caller can see — the hub\'s feed.
     * @param {Array<string>} [projectIds] Narrow the feed to these projects. Empty — every project the caller sees.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListActivity(
      projectIds?: Array<string>,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListActivityResponse> {
      return localVarFp
        .projectServiceListActivity(projectIds, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the columns of a board, left to right.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListBoardColumns(
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListBoardColumnsResponse> {
      return localVarFp
        .projectServiceListBoardColumns(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the labels of a project.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListLabels(
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListLabelsResponse> {
      return localVarFp
        .projectServiceListLabels(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the people on a project.
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListProjectMembers(
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListProjectMembersResponse> {
      return localVarFp
        .projectServiceListProjectMembers(projectId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the projects the caller may see: public ones, plus private ones they belong to. System projects are left out unless asked for.
     * @param {boolean} [onlyMine] Only projects the caller belongs to.
     * @param {boolean} [includeSystem] Include projects owned by services rather than by people.
     * @param {string} [search]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {boolean} [archived] Archived projects instead of live ones. They are a separate tab in the hub, never a part of the usual list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceListProjects(
      onlyMine?: boolean,
      includeSystem?: boolean,
      search?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      archived?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListProjectsResponse> {
      return localVarFp
        .projectServiceListProjects(
          onlyMine,
          includeSystem,
          search,
          paginationPage,
          paginationPerPage,
          archived,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes someone from a project.
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceRemoveProjectMember(
      projectId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .projectServiceRemoveProjectMember(projectId, userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Sets the left-to-right order of the whole board in one call.
     * @param {string} projectId
     * @param {ProjectServiceReorderBoardColumnsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceReorderBoardColumns(
      projectId: string,
      body: ProjectServiceReorderBoardColumnsBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListBoardColumnsResponse> {
      return localVarFp
        .projectServiceReorderBoardColumns(projectId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds someone to a project, or changes the role of someone already on it.
     * @param {string} projectId
     * @param {string} userId
     * @param {ProjectServiceSetProjectMemberBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceSetProjectMember(
      projectId: string,
      userId: string,
      body: ProjectServiceSetProjectMemberBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerProjectMemberResponse> {
      return localVarFp
        .projectServiceSetProjectMember(projectId, userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a column. Fields left out keep their current values.
     * @param {string} id
     * @param {ProjectServiceUpdateBoardColumnBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceUpdateBoardColumn(
      id: string,
      body: ProjectServiceUpdateBoardColumnBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerBoardColumnResponse> {
      return localVarFp
        .projectServiceUpdateBoardColumn(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a label.
     * @param {string} id
     * @param {ProjectServiceUpdateLabelBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceUpdateLabel(
      id: string,
      body: ProjectServiceUpdateLabelBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerLabelResponse> {
      return localVarFp
        .projectServiceUpdateLabel(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a project. Fields left out keep their current values.
     * @param {string} id
     * @param {ProjectServiceUpdateProjectBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectServiceUpdateProject(
      id: string,
      body: ProjectServiceUpdateProjectBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerProjectResponse> {
      return localVarFp
        .projectServiceUpdateProject(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ProjectServiceApi - object-oriented interface
 */
export class ProjectServiceApi extends BaseAPI {
  /**
   *
   * @summary Replaces the board with one of the presets. Refused while the board still holds tasks: the preset would have nowhere to put them.
   * @param {string} projectId
   * @param {ProjectServiceApplyBoardPresetBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceApplyBoardPreset(
    projectId: string,
    body: ProjectServiceApplyBoardPresetBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceApplyBoardPreset(projectId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a column to the board.
   * @param {string} projectId
   * @param {ProjectServiceCreateBoardColumnBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceCreateBoardColumn(
    projectId: string,
    body: ProjectServiceCreateBoardColumnBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceCreateBoardColumn(projectId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a label.
   * @param {string} projectId
   * @param {ProjectServiceCreateLabelBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceCreateLabel(
    projectId: string,
    body: ProjectServiceCreateLabelBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceCreateLabel(projectId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a project. The caller becomes its first administrator, and the board is filled with one of the two column presets.
   * @param {TrackerCreateProjectRequest} body A new project.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceCreateProject(
    body: TrackerCreateProjectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceCreateProject(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a column. Tasks standing in it move to the column given in the request, so that nothing is left without a place on the board.
   * @param {string} id
   * @param {string} [moveIssuesToColumnId] Where the tasks standing in it go. Required whenever the column holds any.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceDeleteBoardColumn(
    id: string,
    moveIssuesToColumnId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceDeleteBoardColumn(id, moveIssuesToColumnId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a label and takes it off the tasks that carry it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceDeleteLabel(id: string, options?: RawAxiosRequestConfig) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceDeleteLabel(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceDeleteProject(id: string, options?: RawAxiosRequestConfig) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceDeleteProject(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one project.
   * @param {string} id Either the identifier or the key: both are unique, and the interface has the key more often than the identifier.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceGetProject(id: string, options?: RawAxiosRequestConfig) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceGetProject(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a project. Its tasks go with it, and the key becomes free again. Recent events across the projects the caller can see — the hub\'s feed.
   * @param {Array<string>} [projectIds] Narrow the feed to these projects. Empty — every project the caller sees.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceListActivity(
    projectIds?: Array<string>,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceListActivity(projectIds, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the columns of a board, left to right.
   * @param {string} projectId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceListBoardColumns(projectId: string, options?: RawAxiosRequestConfig) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceListBoardColumns(projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the labels of a project.
   * @param {string} projectId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceListLabels(projectId: string, options?: RawAxiosRequestConfig) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceListLabels(projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the people on a project.
   * @param {string} projectId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceListProjectMembers(projectId: string, options?: RawAxiosRequestConfig) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceListProjectMembers(projectId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the projects the caller may see: public ones, plus private ones they belong to. System projects are left out unless asked for.
   * @param {boolean} [onlyMine] Only projects the caller belongs to.
   * @param {boolean} [includeSystem] Include projects owned by services rather than by people.
   * @param {string} [search]
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {boolean} [archived] Archived projects instead of live ones. They are a separate tab in the hub, never a part of the usual list.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceListProjects(
    onlyMine?: boolean,
    includeSystem?: boolean,
    search?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    archived?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceListProjects(
        onlyMine,
        includeSystem,
        search,
        paginationPage,
        paginationPerPage,
        archived,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes someone from a project.
   * @param {string} projectId
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceRemoveProjectMember(
    projectId: string,
    userId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceRemoveProjectMember(projectId, userId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Sets the left-to-right order of the whole board in one call.
   * @param {string} projectId
   * @param {ProjectServiceReorderBoardColumnsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceReorderBoardColumns(
    projectId: string,
    body: ProjectServiceReorderBoardColumnsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceReorderBoardColumns(projectId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds someone to a project, or changes the role of someone already on it.
   * @param {string} projectId
   * @param {string} userId
   * @param {ProjectServiceSetProjectMemberBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceSetProjectMember(
    projectId: string,
    userId: string,
    body: ProjectServiceSetProjectMemberBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceSetProjectMember(projectId, userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a column. Fields left out keep their current values.
   * @param {string} id
   * @param {ProjectServiceUpdateBoardColumnBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceUpdateBoardColumn(
    id: string,
    body: ProjectServiceUpdateBoardColumnBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceUpdateBoardColumn(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a label.
   * @param {string} id
   * @param {ProjectServiceUpdateLabelBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceUpdateLabel(
    id: string,
    body: ProjectServiceUpdateLabelBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceUpdateLabel(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a project. Fields left out keep their current values.
   * @param {string} id
   * @param {ProjectServiceUpdateProjectBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public projectServiceUpdateProject(
    id: string,
    body: ProjectServiceUpdateProjectBody,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectServiceApiFp(this.configuration)
      .projectServiceUpdateProject(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
